import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  // AccordionIcon,
  Box,
} from "@chakra-ui/react";

import { AddIcon, MinusIcon } from '@chakra-ui/icons'
const AccordionCard = () => {
  return (

    <>
    <div  className="mx-28  sm:w-[68%] md:w-[75%] lg:w-[83%]">
      <div>
    <Accordion
      allowToggle
      className="m-auto mt-10 py-10"
      >
        {/* <div>

      <AccordionItem className="w-[100%] p-4 bg-gray-200 justify-items-center rounded-sm border-b-2 border-red-800 mb-4">
    
      {({ isExpanded }) => (
      
      <>
        <h2>
          <AccordionButton>
            <Box as="span" flex='1' textAlign='left' className="text-2xl">
            Eligibility Criteria
            </Box>
            {isExpanded ? (
              <MinusIcon fontSize='16px' color='maroon' />
            ) : (
              <AddIcon fontSize='16px' color='maroon' />
            )}
          </AccordionButton>
        </h2>
      
        <AccordionPanel pb={4} pt={2} className="mt-2">
          <li>Minimum 16 years of education from HEC recognized DAI/University</li>
          <li>Applicant must clear Admission/aptitude Test of EIMS or (GAT/HAT)</li>
          <li>Interview conducted by the institute</li>
          <li>Required credentials as per HEC policy</li>
        </AccordionPanel>
        </>
      )}
      </AccordionItem>
        </div> */}

        <div>

      <AccordionItem className="w-[100%] p-4 bg-gray-200 justify-items-center rounded-sm border-b-2 border-red-800 mb-4">
    
      {({ isExpanded }) => (
      
      <>
        <h2>
          <AccordionButton>
            <Box as="span" flex='1' textAlign='left' className="text-2xl">
            Specializations
            </Box>
            {isExpanded ? (
              <MinusIcon fontSize='16px' color='maroon' />
            ) : (
              <AddIcon fontSize='16px' color='maroon'/>
            )}
          </AccordionButton>
        </h2>
      
        <AccordionPanel pb={4} className="mt-2">
          <li>Finance</li>
          <li>Marketing</li>
          <li>Human Resource Management</li>
          <li>Management Information System</li>
          <li>Supply Chain Management</li>
          <li>Islamic Banking and Finance</li>
          <li>Entrepreneurship</li>
          <li>Project Management</li>
        </AccordionPanel>
        </>
      )}
      </AccordionItem>
        </div>
        <div>

      <AccordionItem className="w-[100%] p-4 bg-gray-200 justify-items-center rounded-sm border-b-2 border-red-800 mb-4">
    
      {({ isExpanded }) => (
      
      <>
        <h2>
          <AccordionButton>
            <Box as="span" flex='1' textAlign='left' className="text-2xl">
            Learning Outcomes
            </Box>
            {isExpanded ? (
              <MinusIcon fontSize='16px' color='maroon' />
            ) : (
              <AddIcon fontSize='16px' color='maroon'/>
            )}
          </AccordionButton>
        </h2>
      
        <AccordionPanel pb={4} className="mt-2">
          {/* <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil nisi ducimus, placeat omnis magni labore quasi fugit unde assumenda? Hic ipsam eos recusandae impedit vero quasi suscipit molestias totam delectus!</li> */}
          {/* <li>Marketing</li> */}
          {/* <li>Human Resource Management</li> */}
          {/* <li>Management Information System</li> */}
        </AccordionPanel>
        </>
      )}
      </AccordionItem>
        </div>
        <div>

      <AccordionItem className="w-[100%] p-4 bg-gray-200 justify-items-center rounded-sm border-b-2 border-red-800 mb-4">
    
      {({ isExpanded }) => (
      
      <>
        <h2>
          <AccordionButton>
            <Box as="span" flex='1' textAlign='left' className="text-2xl">
            Career Options
            </Box>
            {isExpanded ? (
              <MinusIcon fontSize='16px' color='maroon' />
            ) : (
              <AddIcon fontSize='16px' color='maroon'/>
            )}
          </AccordionButton>
        </h2>
      
        <AccordionPanel pb={4} className="mt-2">
          {/* <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil nisi ducimus, placeat omnis magni labore quasi fugit unde assumenda? Hic ipsam eos recusandae impedit vero quasi suscipit molestias totam delectus!</li> */}
          {/* <li>Marketing</li> */}
          {/* <li>Human Resource Management</li> */}
          {/* <li>Management Information System</li> */}
        </AccordionPanel>
        </>
      )}
      </AccordionItem>
        </div>
        <div>

      <AccordionItem className="w-[100%] p-4 bg-gray-200 justify-items-center rounded-sm border-b-2 border-red-800 mb-4">
    
      {({ isExpanded }) => (
      
      <>
        <h2>
          <AccordionButton>
            <Box as="span" flex='1' textAlign='left' className="text-2xl">
            Admission Criteria
            </Box>
            {isExpanded ? (
              <MinusIcon fontSize='16px' color='maroon' />
            ) : (
              <AddIcon fontSize='16px' color='maroon'/>
            )}
          </AccordionButton>
        </h2>
      
        <AccordionPanel pb={4} className="mt-2">
          <li className="text-justify">At least 16 years of education; (BS, MA, MSc, BE, MBBS etc.)or equivalent with at least 2.0 CGPA in last degree or 2nd Division.</li>
          <li>Applicant must clear Admission/aptitude Test of EIMS or (GAT/HAT)</li>
          <li>Interview conducted by the institute</li>
          <li>Required credentials as per HEC policy</li>
        </AccordionPanel>
        </>
      )}
      </AccordionItem>
        </div>

        <div>
           <AccordionItem className="w-[100%] p-4 bg-gray-200 justify-items-center rounded-sm border-b-2 border-red-800 mb-4">

    
      {({ isExpanded }) => (
      
      <>
        <h2>
          <AccordionButton>
            <Box as="span" flex='1' textAlign='left' className="text-2xl">
            Course Structure
            </Box>
            {isExpanded ? (
              <MinusIcon fontSize='16px' color='maroon' />
            ) : (
              <AddIcon fontSize='16px' color='maroon' />
            )}
          </AccordionButton>
        </h2>
         <AccordionPanel pb={4}>
         <table className="mt-5  w-1000 ">
           
            <tr className="border-none bg-maroon h-10   text-slate-50">
            <th className="border-none font-normal">SEMESTER I</th>
            <th className="border-none font-normal">SEMESTER II</th>
            <th className="border-none font-normal">SEMESTER III </th>
            <th className="border-none font-normal">SEMESTER IV </th>
            </tr >
            
            <tr className="m-10 text-justify">
              
              <td className="border-none"><p className="text-center mt-4">Principle of Management </p></td>
              <td className="border-none"><p className="text-center mt-4">Business Statistics </p></td>
              <td className="border-none"><p className="text-center mt-4">Statistical Inference </p></td>
              <td className="border-none"><p className="text-center mt-4">Strategic Management </p></td>
              {/* <td className="border-none">Business Statistics</td>
              <td className="border-none">Statistical Inference</td>
              <td className="border-none">Strategic Management  </td>*/}
            </tr>
            
            <tr className="text-justify">
              
              <td className="border-none"><p className="text-center -mt-5">Introduction to Business Finance </p></td>
              <td className="border-none"><p className="text-center -mt-5">Statistical Inference </p></td>
              <td className="border-none"><p className="text-center -mt-5">Business Research Methods </p></td>
              <td className="border-none"><p className="text-center -mt-5">Strategic Marketing </p></td>
             
            </tr>
            <tr className="">    
              <td className="border-none"><p className="text-center -mt-5">Financial Accounting </p></td>
              <td className="border-none"><p className="text-center -mt-5">Macro Economics </p></td>
              <td className="border-none"><p className="text-center -mt-5">Elective I</p></td>
              <td className="border-none"><p className="text-center -mt-5">Strategic Finance </p></td>
            </tr>
            <tr className="">
              
              <td className="border-none"><p className="text-center -mt-5">Micro Economics </p></td>
              <td className="border-none"><p className="text-center -mt-5">Financial Management </p></td>
              <td className="border-none"><p className="text-center -mt-5">Elective II </p></td>
              <td className="border-none"><p className="text-center -mt-5">Elective III </p></td>
       
            </tr>
            <tr className="">
              
              <td className="border-none"><p className="text-center -mt-5">Principle of Marketing </p></td>
              <td className="border-none"><p className="text-center -mt-5">Business Statistics </p></td>
              <td className="border-none"><p className="text-center -mt-5">Statistical Inference </p></td>
              <td className="border-none"><p className="text-center -mt-5">Strategic Management </p></td>
             
            </tr>
            {/* <tr>
              <td className="border-none">Principle of Management</td>
              <td className="border-none">Business Statistics</td>
              <td className="border-none">Statistical Inference</td>
              <td className="border-none">Strategic Management  </td>
            </tr>
            <tr>
              <td className="border-none">Principle of Management</td>
              <td className="border-none">Business Statistics</td>
              <td className="border-none">Statistical Inference</td>
              <td className="border-none">Strategic Management  </td>
            </tr>
            <tr>
              <td className="border-none">Principle of Management</td>
              <td className="border-none">Business Statistics</td>
              <td className="border-none">Statistical Inference</td>
              <td className="border-none">Strategic Management  </td>
            </tr> */}
          </table>
        </AccordionPanel>
        </>
      )}
             </AccordionItem>
        </div>
  











       {/* <div>
      <AccordionItem className="w-[480px] h-fit border-2 border-black mb-4">
        <h2>
          <AccordionButton>
            <Box as="span" flex="1" textAlign="left" fontWeight="medium">
              Duration
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel pb={4}>
          The minimum duration for completion of BS degree is four years. As per
          HEC rules, a maximum period of seven years is required to complete BS
          degree program.
        </AccordionPanel>
      </AccordionItem>
          </div> 
      <div>
         
      <AccordionItem className="w-[480px] h-fit border-2 border-black mb-4">
        <h2>
          <AccordionButton>
            <Box as="span" flex="1" textAlign="left" fontWeight="medium">
              Degree Completion Requirements
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel pb={4}>
          <p>
            To become eligible for award of BS degree, a student must satisfy
            the following requirements:
          </p>
          <li>
            Must have studied and passed the prescribed courses, totaling at
            least 130 credit hours.
          </li>
          <li>
            Must have earned CGPA (Cumulative Grade Point Average) of at least
            2.0 on a scale of 4.0.
          </li>
        </AccordionPanel>
      </AccordionItem>
      </div> */}
    </Accordion>
      </div>
    </div>
    </>
  );
};

export default AccordionCard;
